$(function(){
    console.log('hello world');
    initslideShow();
    initsubslide();
    addclassCartDrawer();
    if ($(".jsc-main-atc").length > 0) {
    onscrollCheckATC($(".jsc-main-atc"));
    $(window).scroll(function() {
        onscrollCheckATC($(".jsc-main-atc"));
    });
    }
    if (location.href.includes('/products')) {
        onloadimgColswap();
    }
});

addclassCartDrawer = () =>{
    var timesRun = 0;
    var timer = setInterval(function() {

        if ($(".cart-drawer").length > 0 ) {
            $(".cart-drawer").parents('.flyout').addClass('jsc-cart-drawer-index');
            clearInterval(timer);
        }
    }, 100);
}

changeTab = (e) =>{
    var $thisTitle = $(e).attr('data-title');
    $('.jsc-tab-product-title').removeClass('jsc-tabProd-active');
    $('.jsc-tab-product-content').removeClass('jsc-tabProdcont-active');
    $(e).addClass('jsc-tabProd-active');

    $(".jsc-tab-product-content").each(function() {
        if ($(this).attr('data-title') == $thisTitle) {
            $(this).addClass('jsc-tabProdcont-active');
        }
    });
}

initslideShow = () =>{

    $('.jsc-img').flickity({
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        groupCells: true,
        imagesLoaded: true,
        adaptiveHeight: true,
        wrapAround: true
    });

    $('.jsc-slide-announcement').flickity({
        // options
        cellAlign: 'center',
        contain: true,
        pageDots: false,
        groupCells: false,
        imagesLoaded: true,
        adaptiveHeight: true,
        autoPlay: 3000,
        wrapAround: true
    });

}

initsubslide = () =>{
    if ($('.jsc-subSlide').length > 0) {
        $('.jsc-subSlide').flickity({
            // options
            cellAlign: 'left',
            contain: true,
            pageDots: false,
            groupCells: true,
            imagesLoaded: true,
            adaptiveHeight: false,
            watchCSS: true,
            wrapAround: false
        });
    }

}
// Start - ATC sticky
onclickvariant = () =>{
    setTimeout(function(){
        var varID = $('.jsc-variant-select').val();
        var varAvai = $('.jsc-variant-select').attr('data-avai');
        if (!varAvai) {
            varAvai = $('.jsc-variant-select').find(':selected').attr('data-avai');
        }
        if (varAvai == 'true') {
            $('.sticky-item').find('.sticky-add-to-cart').removeClass("disabled");
            $('.sticky-item').find('.sticky-add-to-cart').text("Add to cart");
        }else{
            $('.sticky-item').find('.sticky-add-to-cart').addClass("disabled");
            $('.sticky-item').find('.sticky-add-to-cart').text("Sold out");
        }

        var prodCode = $('.jsc-variant-select').find(':selected').attr('data-prodCode');
        var gender = $('.jsc-variant-select').find(':selected').attr('data-gender');
        var outerCom = $('.jsc-variant-select').find(':selected').attr('data-outerCom');
        var infocolour = $('.jsc-variant-select').find(':selected').attr('data-infocolour');
        var careIns = $('.jsc-variant-select').find(':selected').attr('data-careIns');
        $('.jsc-moreInfo td[data-th="Product Code"]').html(prodCode);
        $('.jsc-moreInfo td[data-th="Gender"]').html(gender);
        $('.jsc-moreInfo td[data-th="Outer Composition"]').html(outerCom);
        $('.jsc-moreInfo td[data-th="Colour"]').html(infocolour);
        $('.jsc-moreInfo td[data-th="Care Instructions"]').html(careIns);

        var prodlabelScr = $('.jsc-variant-select').find(':selected').attr('data-prodlabelimg');
        var varlabelScr = $('.jsc-variant-select').find(':selected').attr('data-varlabelimg');

        if (varlabelScr) {
            $('.jsc-promo-logo-pdp').children().remove();
            $('.jsc-promo-logo-pdp').append('<img class="jsc-promo-logo-pdp-img" src="'+ varlabelScr +'" alt="">');
        }else if (prodlabelScr) {
            $('.jsc-promo-logo-pdp').children().remove();
            if ($('.jsc-variant-select').find('[data-varlabelimg]').length > 0 || $('.jsc-variant-select[data-varlabelimg]').length > 0) {
            }else{
                $('.jsc-promo-logo-pdp').append('<img class="jsc-promo-logo-pdp-img" src="'+ varlabelScr +'" alt="">');
            }
        }
        if(variantChange){
          variantChange(varID);
        }
    },100);
}

onclickOpenVar = () =>{
    $('.jsc-float-atc').toggleClass("open-sticky");
}

onchangeInputMain = (e) =>{
    $('.jsc-qty-sticky').val($(e).val());
}

onclickplusminusMain = () =>{
    setTimeout(function(){
        $('.jsc-qty-sticky').val($('.jsc-input-prod').val());
    },100);
}

onchangeInputSticky = (e) =>{
    $('.jsc-input-prod').val($(e).val());
}

onclickplusminusSticky = (val) =>{
    var uptQty = parseInt($('.jsc-qty-sticky').val()) + parseInt(val);
    if (uptQty < 1) {
        uptQty = 1
    }
    $('.jsc-qty-sticky').val(uptQty);
    $('.jsc-input-prod').val(uptQty);
}

onclickSelectVar = (e) =>{
    $('.pr-swatch').removeClass("active");
    $(e).addClass("active");
    var varTitle = $(e).attr('data-title');
    var arrayVar = varTitle.split("/");
    var varImg = $(e).attr('data-img');
    $('.sticky-item img').attr('src', varImg);

    $(e).addClass("active-click");

    for ( i=0; i < arrayVar.length; i++ ){
        var trimVar = arrayVar[i].trim();
        $(".option-selectable-boxes").each(function(index) {
            if (index == i ) {
                var this1 = $(this);
                if (this1.find('.input-radio').length > 0) {
                    this1.find('.input-radio').each(function(index) {
                        var valRadio = $(this).find('.input-radio__input').val();
                        if (valRadio == trimVar) {
                            $(this).find('.input-radio__input').click();
                        }
                    });
                }else{
                    this1.find('.input-swatch').each(function(index) {
                        var valSwatch = $(this).find('.input-swatch__input').val();
                        if (valSwatch == trimVar) {
                            $(this).find('.input-swatch__input').click();
                        }
                    });
                }
            }
        });
    }
}

onclickAtcsticky = (e) =>{
    if ($(e).hasClass("disabled")) {
    }else{
        $(".jsc-main-atc").click();
        $(e).attr('data-loading', '');
        setTimeout(function(){
            $(e).removeAttr('data-loading');
        },1500);
    }
}
onscrollCheckATC = (e) =>{
    var winTop = $(window).scrollTop();
    var winBottom = winTop + $(window).height();
    var elTop = e.offset().top;
    var elBottom = elTop + e.height();
    if ((elBottom<= winBottom) && (elTop >= winTop)) {
        $('.jsc-float-atc').addClass("hide");
    }else {
        $('.jsc-float-atc').removeClass("hide");
    }
}
// End - ATC sticky

// Start - Tab Section
changeTabSection = (e) =>{
    var $thisTitle = $(e).attr('data-title');
    $('.jsc-tab-product-title').removeClass('jsc-tabProd-active');
    $('.jsc-tab-product-content').removeClass('jsc-tabProdcont-active');
    $(e).addClass('jsc-tabProd-active');

    $(".jsc-tab-product-content").each(function() {
        if ($(this).attr('data-title') == $thisTitle) {
            $(this).addClass('jsc-tabProdcont-active');
        }
    });
}
// End - Tab Section

// Start - Image Color swap
onclickimgColswap = (col) =>{
    $('.jsc-imgGallery').each(function(){
        var $img_alt = $(this).attr('data-alt').toLowerCase();
        var $Prod_title = $(this).attr('data-prodtitle').toLowerCase();
        col = col.toLowerCase();
        if (($img_alt == col) || ($img_alt == 'main_image') || ($img_alt == $Prod_title)) {
            $(this).show();
            $(this).removeClass('jsc-hide-gallery');
        }else{
            $(this).hide();
            $(this).addClass('jsc-hide-gallery');
        }
    });
    $('.jsc-galleryZoom').each(function(){
        var $img_alt = $(this).attr('data-alt').toLowerCase();
        var $Prod_title = $(this).attr('data-prodtitle').toLowerCase();
        col = col.toLowerCase();
        if (($img_alt == col) || ($img_alt == 'main_image') || ($img_alt == $Prod_title)) {
            $(this).show();
            $(this).removeClass('jsc-hide-gallery');
        }else{
            $(this).hide();
            $(this).addClass('jsc-hide-gallery');
        }
    });
    $('.jsc-galleryThumb').each(function(){
        var $img_alt = $(this).attr('data-alt').toLowerCase();
        var $Prod_title = $(this).attr('data-prodtitle').toLowerCase();
        col = col.toLowerCase();
        if (($img_alt == col) || ($img_alt == 'main_image') || ($img_alt == $Prod_title)) {
            $(this).show();
            $(this).removeClass('jsc-hide-gallery');
        }else{
            $(this).hide();
            $(this).addClass('jsc-hide-gallery');
        }
    });
    console.log($('.jsc-pdp-gallery .jsc-imgGallery').length - $('.jsc-pdp-gallery .jsc-hide-gallery').length);
    $('.jsc-total-img').text($('.jsc-pdp-gallery .jsc-imgGallery').length - $('.jsc-pdp-gallery .jsc-hide-gallery').length);
}
onloadimgColswap = () =>{
    var col = $('.jsc-inputSwatch').find(':checked').val();
    $('.jsc-imgGallery').each(function(){
        var $img_alt = $(this).attr('data-alt').toLowerCase();
        var $Prod_title = $(this).attr('data-prodtitle').toLowerCase();
        col = col.toLowerCase();
        if (($img_alt == col) || ($img_alt == 'main_image') || ($img_alt == $Prod_title)) {
            $(this).show();
            $(this).removeClass('jsc-hide-gallery');
        }else{
            $(this).hide();
            $(this).addClass('jsc-hide-gallery');
        }
    });
    $('.jsc-galleryZoom').each(function(){
        var $img_alt = $(this).attr('data-alt').toLowerCase();
        var $Prod_title = $(this).attr('data-prodtitle').toLowerCase();
        col = col.toLowerCase();
        if (($img_alt == col) || ($img_alt == 'main_image') || ($img_alt == $Prod_title)) {
            $(this).show();
            $(this).removeClass('jsc-hide-gallery');
        }else{
            $(this).hide();
            $(this).addClass('jsc-hide-gallery');
        }
    });
    $('.jsc-galleryThumb').each(function(){
        var $img_alt = $(this).attr('data-alt').toLowerCase();
        var $Prod_title = $(this).attr('data-prodtitle').toLowerCase();
        col = col.toLowerCase();
        if (($img_alt == col) || ($img_alt == 'main_image') || ($img_alt == $Prod_title)) {
            $(this).show();
            $(this).removeClass('jsc-hide-gallery');
        }else{
            $(this).hide();
            $(this).addClass('jsc-hide-gallery');
        }
    });
}


var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}
// End - Tab Section